import { Injectable } from '@angular/core';
import Intercom, { hide, hideNotifications, shutdown } from '@intercom/messenger-js-sdk';
import { CustomerChatbotService } from './types';
import { ITokenPayload, IUser } from '@azavista/planner-lib';

const INTERCOM_APP_ID = 'rmafpc15';

@Injectable({
    providedIn: 'root',
})
export class IntercomCustomerChatbotService extends CustomerChatbotService {
    private readonly querySelectorValue = '#intercom-container, .intercom-launcher';

    async showChatbot() {
        this.toggleHideButton(false);
    }

    async hideChatbot() {
        hideNotifications(true);
        hide();
        this.toggleHideButton(true);
    }
    private isElectron(): boolean {
        return navigator.userAgent.toLowerCase().includes('electron');
    }

    private toggleHideButton(hide: boolean) {
        const intercomButton = document.querySelector<HTMLElement>(this.querySelectorValue);
        if (intercomButton) {
            if (hide) {
                intercomButton.style.display = 'none';
            } else if (intercomButton.style.display === 'none') {
                intercomButton.style.removeProperty('display');
            }
        }
    }

    async initUserSession(user: IUser, token: ITokenPayload): Promise<void> {
        if (this.isElectron()) return; // skip Intercom in Electron
        shutdown()
        const { email, id: user_id, first_name, last_name } = user;
        const { c: customer_id } = token;
        Intercom({
            app_id: INTERCOM_APP_ID,
            email,
            company: {
                company_id: `${customer_id}`,
            },
            alignment: 'left',
            user_id: `${user_id}`,
            name: `${first_name} ${last_name}`.trim(),
        });
        this.hideNotificationCount();
    }
    async endUserSession(): Promise<void> {
        await this.initUnAuthenticatedUser();
    }
    async initUnAuthenticatedUser() {
        shutdown();
        Intercom({
            app_id: INTERCOM_APP_ID,
        });
        this.hideNotificationCount();
    }

    private async hideNotificationCount() {
        const style = document.createElement('style');
        style.innerHTML = `*:has( > *[data-testid="active-notifications"][class*="intercom-with-namespace"]) { display: none !important; }`;
        document.body.appendChild(style);
    }
}
